import ContactForm from "../ContactFrom/ContactForm";

const Contactpage = () => {
  return (
    <>
      <div className="container">
        <div className="row mt-5 ">
          <div className="col col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-5">
            <section className="wpo-contact-map-section shadow bg-body rounded-3">
              <div className="wpo-contact-map ">
                <iframe
                  title="comtact-map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243.1261885072871!2d80.22640044362014!3d12.842047612652722!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525a50a54bde0b%3A0x565856a9ccaf6b3!2sSSPDL!5e0!3m2!1sen!2sin!4v1752566198054!5m2!1sen!2sin"
                  style={{
                    width: "100%",
                    height: "400px",

                    display: "block",
                    marginBottom: 0,
                    paddingBottom: 0,
                  }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </section>
          </div>

          <div className="col col-xl-6 col-lg-6 col-md-6 col-12 mb-5"
            style={{ display: "flex" }}
          >
            <div
              className="office-info-item"
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                border: "1.5px solid #08124d",
                borderRadius: 12,
              }}
            >
              <div className="office-info-text text-center ">
                <h2>INDIA</h2>
                <h4>Thinkbig infotech (India) private limited</h4>
                <p className="m-0">
                  Alpha Block, 3rd Floor,SSPDL Building, <br />
                  OMR Road,Navalur, Chennai - 600 130.
                </p>
                <p>info@tbiti.com</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row ">
          <div className="col col-xl-6 col-lg-6 col-md-6 col-12 mb-5 order-2 order-lg-1"
            style={{ display: "flex" }}
          >
            <div className="office-info-item"
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                border: "1.5px solid #08124d",
                borderRadius: 12,
              }}
            >
              <div className="office-info-text text-center">
                <h2>USA</h2>
                <h4>Thinkbig infotech LLC</h4>
                <p className="m-0">16192 Coastal Hwy, Lewes, DE 19958, USA.</p>
                <p>info@tbiti.com</p>
              </div>
            </div>
          </div>

          <div className="col col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-5 order-1 order-lg-2">
            <section className="wpo-contact-map-section shadow bg-body rounded-3">
              <div className="wpo-contact-map ">
                <iframe
                  title="comtact-map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3110.9433651072654!2d-75.21415252334502!3d38.765002971752644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b8b90d99b44b9b%3A0xfba6eb4b8adf94b8!2s16192%20Coastal%20Hwy%2C%20Lewes%2C%20DE%2019958%2C%20USA!5e0!3m2!1sen!2sin!4v1724053776573!5m2!1sen!2sin"
                  style={{
                    width: "100%",
                    height: "400px",

                    display: "block",
                    marginBottom: 0,
                    paddingBottom: 0,
                  }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </section>
          </div>
        </div>
      </div>
      <section className="wpo-contact-pg-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col col-lg-10 offset-lg-1">
              {/* <div className="office-info">
                <div
                  className="row"
                  style={{ display: "flex", alignItems: "stretch" }}
                >
                  <div
                    className="col col-xl-4 col-lg-6 col-md-6 col-12"
                    style={{ display: "flex" }}
                  >
                    <div 
                      className="office-info-item"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        border: "1.5px solid #08124d",
                        borderRadius: 12,
                      }}
                    >
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-placeholder"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Address</h2>
                        <p>
                          1.SSPDL, OMR, Navalur, Chennai, Tamil Nadu 603103.
                        </p>
                        <p>2.16192 Coastal Hwy, Lewes, DE 19958, USA.</p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col col-xl-4 col-lg-6 col-md-6 col-12"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="office-info-item"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        border: "1.5px solid #08124d",
                        borderRadius: 12,
                      }}
                    >
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-email"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Email Us</h2>
                        <p>info@tbiti.com</p>
                      </div>
                    </div>
                  </div>
                  
                  <div
                    className="col col-xl-4 col-lg-6 col-md-6 col-12"
                    style={{ display: "flex" }}
                  >
                    <div
                      className="office-info-item"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        border: "1.5px solid #08124d",
                        borderRadius: 12,
                      }}
                    >
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-phone-call"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Call Now</h2>
                        <p>+91 93636 28810</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="wpo-contact-title">
                <h2>Have Any Question?</h2>
                <p>
                  We're here to help and answer any question you might have. We
                  look forrward to hearing from you.
                </p>
              </div>
              <div
                className="wpo-contact-form-area"
                style={{
                  background: "rgba(255,255,255,0.95)",
                  borderRadius: 12,
                  boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                  padding: 32,
                }}
              >
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
        {/* Add gap then map below, map stretches to footer */}
        <div style={{ height: 135 }}></div>
      </section>
    </>
  );
};

export default Contactpage;
